import { lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Layout from './components/layout/Layout';
import ErrorBoundary from './components/common/ErrorBoundary';
import ScrollToTop from './components/common/ScrollToTop';
import Home from './pages/Home';

const Intake = lazy(() => import('./pages/Intake'));
const Capabilities = lazy(() => import('./pages/Capabilities'));
const About = lazy(() => import('./pages/About'));
const Cookies = lazy(() => import('./pages/Cookies'));
const Privacy = lazy(() => import('./pages/Privacy'));
const Legal = lazy(() => import('./pages/Legal'));
const NotFound = lazy(() => import('./pages/NotFound'));

const MinimalLoadingFallback = () => (
  <div
    style={{
      minHeight: '50vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <div
      style={{
        width: '36px',
        height: '36px',
        border: '3px solid #e5e7eb',
        borderTop: '3px solid #007AFF',
        borderRadius: '50%',
        animation: 'spin 1s linear infinite',
      }}
    />
    <style>{`
      @keyframes spin {
        to { transform: rotate(360deg); }
      }
    `}</style>
  </div>
);

function App() {
  return (
    <ErrorBoundary>
      <HelmetProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route index element={<Home />} />
              <Route
                path="request"
                element={
                  <Suspense fallback={<MinimalLoadingFallback />}>
                    <Intake />
                  </Suspense>
                }
              />
              <Route
                path="capabilities"
                element={
                  <Suspense fallback={<MinimalLoadingFallback />}>
                    <Capabilities />
                  </Suspense>
                }
              />
              <Route
                path="about"
                element={
                  <Suspense fallback={<MinimalLoadingFallback />}>
                    <About />
                  </Suspense>
                }
              />
              <Route
                path="cookies"
                element={
                  <Suspense fallback={<MinimalLoadingFallback />}>
                    <Cookies />
                  </Suspense>
                }
              />
              <Route
                path="privacy"
                element={
                  <Suspense fallback={<MinimalLoadingFallback />}>
                    <Privacy />
                  </Suspense>
                }
              />
              <Route
                path="legal"
                element={
                  <Suspense fallback={<MinimalLoadingFallback />}>
                    <Legal />
                  </Suspense>
                }
              />
              <Route
                path="*"
                element={
                  <Suspense fallback={<MinimalLoadingFallback />}>
                    <NotFound />
                  </Suspense>
                }
              />
            </Route>
          </Routes>
        </BrowserRouter>
      </HelmetProvider>
    </ErrorBoundary>
  );
}

export default App;
